module.exports = __webpack_public_path__ + "static/media/error.cddafd64.svg";